import axios from "axios";
import router from "@/router";
import i18n from "../../i18n";
import moment from "moment";
export default {
  state: {
    qnaStatus: null,
    qnaKeyword: "",
    wrongAnswerCount: 0,
    court: "",
    faqCategory: "",
    isThinking: false,
    requestQna: true,
  },
  getters: {
    getQnaStatus: (state) => state.qnaStatus,
    getQnaKeyword: (state) => state.qnaKeyword,
    getWrongAnsCount: (state) => state.wrongAnswerCount,
    getCourt: (state) => state.court,
    getFaqCategory: (state) => state.faqCategory,
    getIsThinking: (state) => state.isThinking,
    getRequestQna: (state) => state.requestQna,
  },
  mutations: {
    setQnaStatus(state, status) {
      state.qnaStatus = status;
    },
    setQnaKeyword(state, keyword) {
      state.qnaKeyword = keyword;
    },
    setWrongAnswerCount(state, count) {
      state.wrongAnswerCount = count;
    },
    setCourt(state, court) {
      state.court = court;
    },
    setFaqCategory(state, category) {
      state.faqCategory = category;
    },
    setIsThinking(state, status) {
      state.isThinking = status;
    },
    setRequestQna(state, status) {
      state.requestQna = status;
    },
  },
  actions: {
    requestQnA({ getters, dispatch, commit }, transcript) {
      // Request to QNA
      if (getters.isThinking) {
        commit("setSpeechTranscript", transcript);
        commit("setTextBubbleText", transcript);
      }
      let data = JSON.stringify({
        question: transcript,
        lang: "english",
        client: "kcmo",
      });
      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: "https://zjul4g7rfl.execute-api.us-east-1.amazonaws.com/stage/api/query",
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
      console.log("what is the config: ", config);
      commit("setIsThinking", true);
      commit("setTextBubbleText", "Thinking....");
      axios
        .request(config)
        .then((response) => {
          console.log("Response from AI: ", response.data);
          dispatch("addSessionDatatoStrapi", {
            applicationId: getters.getKioskProfile.data().applicationId,
            applicationSessionId: getters.getSessionId,
            timeStamp: moment().toISOString(),
            actionType: "Speech",
            sessionPayload: {
              transcript: transcript,
              action: "AI Requested",
              response: response.data,
            },
          });
          dispatch("addInteractionToPostgres", {
            actionType: "Interaction",
            actionPayload: {
              module: "QnA",
              navigateFrom: "Home",
              navigateTo: "Home",
              interactionType: "Speech",
              elementContent: {
                question: transcript,
                answer: response.data.answer.response,
                confidenceScore: response.data.answer.confidenceScore,
              },
            },
          });
          dispatch("generateAnswer", response.data);
        })
        .catch((error) => {
          commit("setIsThinking", false);
          console.log(error);
        });
    },
    generateAnswer({ dispatch, commit, getters }, result) {
      if (getters.getIsThinking) {
        commit("setQnaStatus", false);
        const metadata = result.answer.intent;
        const ansObj = result.answer;
        console.log("Whats is in the answer object: ", ansObj);
        commit("setDefaultBubbleText", false);
        commit("closeOptionsViewer");
        switch (metadata) {
          case "navigate":
            var menuName = ansObj.metadata.path;
            router.addRoute({
              path: menuName.toLowerCase(),
              component: () => import("@/views/" + menuName),
            });
            if (router.currentRoute.path !== menuName) {
              router.push(menuName).then(() => {
                commit("setQnaKeyword", "");
                dispatch("avatarSpeak", ansObj.response);
                let page = i18n
                  .t("homepages")
                  .filter((page) => page.pageType[0].pathName === menuName);
                commit("setPageHeader", page[0].pageType[0].pageHeader);
              });
            } else {
              commit("setQnaKeyword", "");
              dispatch("avatarSpeak", ansObj.response);
            }
            break;

          case "showmap":
            try {
              console.log("Map List: ", i18n.t("maps"));
              console.log("ansObj.metadata.mappath: ", ansObj.metadata.mappath);
              var mapPath = i18n
                .t("maps")
                .filter(
                  (map) =>
                    map.mapName.toLowerCase() ===
                    ansObj.metadata.mappath.toLowerCase()
                );
              console.log("Map FOund", mapPath);
              dispatch("openImageViewer", {
                name: mapPath[0].mapName,
                url: mapPath[0].mapImage,
              });
              dispatch("avatarSpeak", mapPath[0].speech);
            } catch (e) {
              mapPath = getters.getMaps.get(
                getters.getDefaultLocation.toLowerCase()
              );
              dispatch("openImageViewer", {
                name: mapPath.mapName,
                url: mapPath.mapImage,
              });
              dispatch("avatarSpeak", i18n.t("mapNotFound"));
            }

            break;

          case "speak":
            dispatch("avatarSpeak", ansObj.response);
            break;

          case "searchbylinkid":
            commit("setQnaKeyword", "");
            if (router.currentRoute.path !== "/faqs") {
              router.push("/faqs");
            }
            commit("setPageHeader", "Frequently Asked Questions");
            var linkId = ansObj.metadata.linkid;
            commit("setQnaKeyword", linkId);
            dispatch("avatarSpeak", ansObj.response);
            break;

          case "showhours":
            dispatch("openCourtTimingViewer", {});
            dispatch("avatarSpeak", ansObj.answer);

            break;

          case "followup":
            dispatch("avatarSpeak", ansObj.response);
            dispatch("openOptionsViewer", {
              dialogHeader: i18n.t("selectOptionMsg"),
              dialogData: ansObj.metadata.followup.split(","),
            });
            break;
          default:
            mapPath = getters.getMaps.get(
              getters.getDefaultLocation.toLowerCase()
            );
            dispatch("openImageViewer", {
              name: mapPath.mapName,
              url: mapPath.mapImage,
            });
            dispatch("avatarSpeak", i18n.t("kbError"));
            break;
        }
      }
    },
  },
};
